import { render, staticRenderFns } from "./logisticSupplyExpirations.vue?vue&type=template&id=63a4939d&scoped=true"
import script from "./logisticSupplyExpirations.vue?vue&type=script&lang=js"
export * from "./logisticSupplyExpirations.vue?vue&type=script&lang=js"
import style0 from "./logisticSupplyExpirations.vue?vue&type=style&index=0&id=63a4939d&prod&lang=css"
import style1 from "./logisticSupplyExpirations.vue?vue&type=style&index=1&id=63a4939d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a4939d",
  null
  
)

export default component.exports